(function () {
  "use strict";
  var ROSTER = "_ddey_course_students";
  var MODE = "_ddey_course_roster_mode";
  var GROUP = "_ddey_course_group";
  function cleanName(value) {
    return typeof value === "string"
      ? value
          .replace(/[\u0000-\u001f\u007f]/g, " ")
          .trim()
          .slice(0, 160)
      : "";
  }
  function cleanEmail(value) {
    return typeof value === "string"
      ? value
          .replace(/[\u0000-\u001f\u007f\s]/g, "")
          .trim()
          .slice(0, 254)
      : "";
  }
  function size(value) {
    var n = Number(value);
    return Number.isSafeInteger(n) && n > 0 ? Math.min(n, 50) : 1;
  }
  function normalizeMode(value) {
    return value === "private" ? "private" : "seat";
  }
  function readStudents(properties) {
    properties = properties || {};
    var parsed;
    try {
      parsed = JSON.parse(properties[ROSTER]);
    } catch (_) {}
    if (Array.isArray(parsed)) {
      return parsed.slice(0, 50).map(function (student) {
        return {
          name: cleanName(student && student.name),
          email: cleanEmail(student && student.email),
        };
      });
    }
    var students = [];
    for (var i = 1; i <= 50; i += 1) {
      var name = cleanName(properties["Student " + i + " name"]);
      var email = cleanEmail(properties["Student " + i + " email"]);
      if (!name && !email) break;
      students.push({ name: name, email: email });
    }
    return students;
  }
  function makeProperties(original, students, mode, group) {
    var result = Object.assign({}, original || {});
    Object.keys(result).forEach(function (key) {
      if (
        /^Student \d+ (name|email)$/.test(key) ||
        key === ROSTER ||
        key === MODE ||
        key === GROUP
      )
        delete result[key];
    });
    var roster = students.slice(0, 50).map(function (student) {
      return {
        name: cleanName(student.name),
        email: cleanEmail(student.email),
      };
    });
    result[ROSTER] = JSON.stringify(roster);
    result[MODE] = normalizeMode(mode);
    result[GROUP] = group;
    roster.forEach(function (student, index) {
      result["Student " + (index + 1) + " name"] = student.name;
      result["Student " + (index + 1) + " email"] = student.email;
    });
    return result;
  }
  var helpers = {
    cleanName: cleanName,
    cleanEmail: cleanEmail,
    readStudents: readStudents,
    makeProperties: makeProperties,
    ROSTER: ROSTER,
    MODE: MODE,
    GROUP: GROUP,
  };
  if (typeof module !== "undefined" && module.exports) module.exports = helpers;
  if (typeof document === "undefined") return;

  var config = document.getElementById("DdeyCourseStudentConfig");
  if (!config) return;
  var text = config.dataset;
  var root =
    window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/";
  var cartStates = new Map();
  var serial = 0;
  var saveChain = Promise.resolve();
  var replayingCheckout = false;
  var refreshTimer;
  function uniqueGroup() {
    return (
      "course-" +
      Date.now().toString(36) +
      "-" +
      Math.random().toString(36).slice(2)
    );
  }
  function element(tag, className, content) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (content !== undefined) node.textContent = content;
    return node;
  }
  function normalizedStudents(students, count) {
    return Array.from({ length: size(count) }, function (_, index) {
      var student = students[index] || {};
      return {
        name: cleanName(student.name),
        email: cleanEmail(student.email),
      };
    });
  }
  function collect(state) {
    return Array.from(
      state.node.querySelectorAll("[data-ddey-course-row]"),
    ).map(function (row) {
      return {
        name: cleanName(row.querySelector("[data-ddey-student-name]").value),
        email: cleanEmail(row.querySelector("[data-ddey-student-email]").value),
      };
    });
  }
  function status(state, message, isError) {
    var node = state.node.querySelector("[data-ddey-course-status]");
    if (node) {
      node.textContent = message;
      node.dataset.error = isError ? "true" : "false";
    }
  }
  function valid(state, report) {
    var inputs = Array.from(
      state.node.querySelectorAll(
        "[data-ddey-student-name], [data-ddey-student-email]",
      ),
    );
    var complete =
      inputs.length >= 2 &&
      inputs.every(function (input) {
        return input.checkValidity();
      });
    if (!complete && report) {
      status(state, text.required, true);
      var first = inputs.find(function (input) {
        return !input.checkValidity();
      });
      if (first) first.reportValidity();
    }
    return complete;
  }
  function drawFields(state, productMode) {
    var fields = state.node.querySelector("[data-ddey-course-fields]");
    fields.replaceChildren();
    state.students.forEach(function (student, index) {
      var number = index + 1;
      var row = element("div", "ddey-course-students__row");
      row.setAttribute("data-ddey-course-row", "");
      row.append(
        element(
          "p",
          "ddey-course-students__number",
          text.studentNumber.replace("__NUMBER__", String(number)),
        ),
      );
      var grid = element("div", "ddey-course-students__grid");
      var nameWrap = element("div");
      var nameId = "DdeyCourseName-" + state.id + "-" + number;
      var nameLabel = element("label", "", text.nameLabel);
      nameLabel.htmlFor = nameId;
      var nameInput = element("input");
      nameInput.id = nameId;
      nameInput.type = "text";
      nameInput.value = student.name;
      nameInput.maxLength = 160;
      nameInput.autocomplete = "name";
      nameInput.required = true;
      nameInput.setAttribute("data-ddey-student-name", "");
      if (productMode)
        nameInput.name = "properties[Student " + number + " name]";
      nameWrap.append(nameLabel, nameInput);
      var emailWrap = element("div");
      var emailId = "DdeyCourseEmail-" + state.id + "-" + number;
      var emailLabel = element("label", "", text.emailLabel);
      emailLabel.htmlFor = emailId;
      var emailInput = element("input");
      emailInput.id = emailId;
      emailInput.type = "email";
      emailInput.value = student.email;
      emailInput.maxLength = 254;
      emailInput.autocomplete = "email";
      emailInput.required = true;
      emailInput.setAttribute("data-ddey-student-email", "");
      if (productMode)
        emailInput.name = "properties[Student " + number + " email]";
      emailWrap.append(emailLabel, emailInput);
      grid.append(nameWrap, emailWrap);
      row.append(grid);
      if (state.mode === "private" && state.students.length > 1) {
        var actions = element("div", "ddey-course-students__actions");
        var remove = element(
          "button",
          "ddey-course-students__remove",
          text.remove,
        );
        remove.type = "button";
        remove.dataset.index = String(index);
        remove.setAttribute("data-ddey-remove-student", "");
        actions.append(remove);
        row.append(actions);
      }
      fields.append(row);
    });
    var add = state.node.querySelector("[data-ddey-add-student]");
    if (add)
      add.hidden = state.mode !== "private" || state.students.length >= 50;
  }
  function resize(state, count, productMode) {
    state.students = normalizedStudents(state.students, count);
    drawFields(state, productMode);
  }
  function updateCheckoutState() {
    var blocked = Array.from(cartStates.values()).some(function (state) {
      return state.node.isConnected && (state.dirty || !valid(state, false));
    });
    document.body.toggleAttribute("data-ddey-course-roster-blocked", blocked);
    document
      .querySelectorAll(".additional-checkout-buttons")
      .forEach(function (node) {
        if (blocked && !node.inert) {
          node.inert = true;
          node.dataset.ddeyCourseInert = "true";
        } else if (!blocked && node.dataset.ddeyCourseInert === "true") {
          node.inert = false;
          delete node.dataset.ddeyCourseInert;
        }
      });
  }
  function markDirty(state) {
    state.students = collect(state);
    state.version += 1;
    state.dirty = true;
    status(
      state,
      valid(state, false) ? text.unsaved : text.required,
      !valid(state, false),
    );
    updateCheckoutState();
    clearTimeout(state.timer);
    state.timer = setTimeout(function () {
      if (valid(state, false)) saveAll().catch(function () {});
    }, 650);
  }
  function wireRosterButtons(state, productMode, changed) {
    var add = state.node.querySelector("[data-ddey-add-student]");
    if (add)
      add.addEventListener("click", function () {
        state.students = collect(state);
        if (state.students.length >= 50) return;
        state.students.push({ name: "", email: "" });
        drawFields(state, productMode);
        changed();
        var names = state.node.querySelectorAll("[data-ddey-student-name]");
        if (names.length) names[names.length - 1].focus();
      });
    state.node.addEventListener("click", function (event) {
      var remove = event.target.closest("[data-ddey-remove-student]");
      if (!remove || state.mode !== "private") return;
      state.students = collect(state);
      state.students.splice(Number(remove.dataset.index), 1);
      if (!state.students.length) state.students.push({ name: "", email: "" });
      drawFields(state, productMode);
      changed();
    });
  }

  document
    .querySelectorAll("[data-ddey-course-students]")
    .forEach(function (node) {
      var form = node.closest("form");
      if (!form) return;
      var mode = normalizeMode(node.dataset.ddeyCourseMode);
      var state = {
        node: node,
        id: ++serial,
        mode: mode,
        students: [{ name: "", email: "" }],
      };
      var roster = element("input");
      roster.type = "hidden";
      roster.name = "properties[" + ROSTER + "]";
      var modeInput = element("input");
      modeInput.type = "hidden";
      modeInput.name = "properties[" + MODE + "]";
      modeInput.value = mode;
      var group = element("input");
      group.type = "hidden";
      group.name = "properties[" + GROUP + "]";
      group.value = uniqueGroup();
      form.append(roster, modeInput, group);
      function sync() {
        state.students = collect(state);
        roster.value = JSON.stringify(state.students);
      }
      var quantity = form.querySelector('[name="quantity"]');
      resize(state, mode === "seat" && quantity ? quantity.value : 1, true);
      sync();
      node.addEventListener("input", sync);
      wireRosterButtons(state, true, sync);
      if (quantity && mode === "seat") {
        quantity.addEventListener("input", function () {
          state.students = collect(state);
          resize(state, quantity.value, true);
          sync();
        });
        quantity.addEventListener("change", function () {
          state.students = collect(state);
          resize(state, quantity.value, true);
          sync();
        });
      }
      function prepare(event) {
        sync();
        if (!valid(state, true)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return false;
        }
        group.value = uniqueGroup();
        return true;
      }
      form.addEventListener("submit", prepare, true);
      form.addEventListener(
        "click",
        function (event) {
          if (
            event.target.closest(
              '[name="add"], [data-add-to-cart], .shopify-payment-button',
            )
          )
            prepare(event);
        },
        true,
      );
    });

  var eligibilityNode = document.getElementById("DdeyCartCourseEligibility");
  if (!eligibilityNode) return;
  var eligibility = {};
  try {
    eligibility = JSON.parse(eligibilityNode.textContent);
  } catch (_) {}
  var cartList = document.querySelector("[data-cart-line-items]");
  if (!cartList) return;
  async function fetchCart() {
    var response = await fetch(root + "cart.js", {
      credentials: "same-origin",
      cache: "no-store",
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error("Cart not available");
    return response.json();
  }
  function identity(item) {
    return (item.properties && item.properties[GROUP]) || item.key;
  }
  function buildCartNode(state) {
    var node = element("fieldset", "ddey-course-students");
    node.setAttribute("data-ddey-cart-course-students", "");
    node.append(
      element("legend", "", text.heading),
      element(
        "p",
        "ddey-course-students__help",
        state.mode === "private" ? text.privateHelp : text.seatHelp,
      ),
    );
    var fields = element("div");
    fields.setAttribute("data-ddey-course-fields", "");
    node.append(fields);
    var add = element("button", "ddey-course-students__add", text.add);
    add.type = "button";
    add.setAttribute("data-ddey-add-student", "");
    node.append(add);
    var save = element("button", "ddey-course-students__save", text.save);
    save.type = "button";
    node.append(save);
    var message = element("p", "ddey-course-students__status");
    message.setAttribute("data-ddey-course-status", "");
    message.setAttribute("role", "status");
    message.setAttribute("aria-live", "polite");
    node.append(message);
    state.node = node;
    node.addEventListener("input", function (event) {
      if (
        event.target.matches(
          "[data-ddey-student-name], [data-ddey-student-email]",
        )
      )
        markDirty(state);
    });
    wireRosterButtons(state, false, function () {
      markDirty(state);
    });
    save.addEventListener("click", function () {
      if (valid(state, true)) saveAll().catch(function () {});
    });
    return node;
  }
  async function refresh() {
    try {
      var cart = await fetchCart();
      var oldWarning = document.getElementById("DdeyCourseRosterLoadError");
      if (oldWarning) oldWarning.remove();
      document.querySelectorAll("[data-cart-item]").forEach(function (row) {
        var item = cart.items.find(function (candidate) {
          return candidate.key === row.getAttribute("data-cart-item-key");
        });
        if (!item) return;
        var saved = readStudents(item.properties);
        var mode =
          (item.properties && item.properties[MODE]) ||
          eligibility[item.variant_id];
        if (!mode && !saved.length) return;
        mode = normalizeMode(mode);
        var key = identity(item);
        var state = cartStates.get(key);
        if (!state) {
          var count =
            mode === "seat" ? item.quantity : Math.max(1, saved.length);
          state = {
            id: ++serial,
            key: item.key,
            group: (item.properties && item.properties[GROUP]) || "",
            mode: mode,
            students: normalizedStudents(saved, count),
            version: 0,
            dirty: !saved.length,
          };
          cartStates.set(key, state);
          buildCartNode(state);
          drawFields(state, false);
          status(
            state,
            valid(state, false)
              ? state.dirty
                ? text.unsaved
                : ""
              : text.required,
            !valid(state, false),
          );
        }
        state.key = item.key;
        row
          .querySelectorAll("[data-cart-item-property]")
          .forEach(function (property) {
            var label = property.querySelector(
              "[data-cart-item-property-name]",
            );
            if (
              label &&
              /^(Student \d+ (name|email)|_ddey_course_students|_ddey_course_roster_mode|_ddey_course_group):\s*$/.test(
                label.textContent.trim(),
              )
            )
              property.classList.add("hide");
          });
        row
          .querySelectorAll("[data-ddey-cart-course-students]")
          .forEach(function (panel) {
            if (panel !== state.node) panel.remove();
          });
        if (!row.contains(state.node))
          (
            row.querySelector("[data-cart-table-cell]") ||
            row.querySelector("td")
          ).appendChild(state.node);
        if (state.mode === "seat" && state.students.length !== item.quantity) {
          state.students = collect(state);
          resize(state, item.quantity, false);
          markDirty(state);
        }
      });
      updateCheckoutState();
    } catch (_) {
      var warning = document.getElementById("DdeyCourseRosterLoadError");
      if (!warning) {
        warning = element(
          "p",
          "ddey-course-students__status",
          text.loadingError,
        );
        warning.id = "DdeyCourseRosterLoadError";
        warning.dataset.error = "true";
        warning.setAttribute("role", "alert");
        cartList.closest("form").prepend(warning);
      }
      document.body.setAttribute("data-ddey-course-roster-blocked", "");
    }
  }
  function saveAll() {
    saveChain = saveChain
      .catch(function () {})
      .then(async function () {
        var states = Array.from(cartStates.values()).filter(function (state) {
          return state.dirty && state.node.isConnected;
        });
        if (!states.length) return;
        if (
          !states.every(function (state) {
            return valid(state, true);
          })
        )
          throw new Error("Student roster is incomplete");
        var cart = await fetchCart();
        for (var state of states) {
          clearTimeout(state.timer);
          var version = state.version;
          var item = cart.items.find(function (candidate) {
            return state.group
              ? candidate.properties &&
                  candidate.properties[GROUP] === state.group
              : candidate.key === state.key;
          });
          if (!item) {
            status(state, text.error, true);
            throw new Error("Cart line changed; refresh required");
          }
          var group = state.group || uniqueGroup();
          status(state, text.saving);
          var response = await fetch(root + "cart/change.js", {
            method: "POST",
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({
              id: item.key,
              quantity: item.quantity,
              properties: makeProperties(
                item.properties,
                state.students,
                state.mode,
                group,
              ),
            }),
          });
          if (!response.ok) {
            status(state, text.error, true);
            throw new Error("Course roster not saved");
          }
          cart = await response.json();
          var updated = cart.items.find(function (candidate) {
            return (
              candidate.properties && candidate.properties[GROUP] === group
            );
          });
          if (!updated) {
            status(state, text.error, true);
            throw new Error("Saved cart line not found");
          }
          var oldIdentity = state.group || state.key;
          state.group = group;
          state.key = updated.key;
          cartStates.delete(oldIdentity);
          cartStates.set(group, state);
          var row = state.node.closest("[data-cart-item]");
          if (row) row.setAttribute("data-cart-item-key", updated.key);
          if (state.version === version) {
            state.dirty = false;
            status(state, text.saved);
          } else status(state, text.unsaved);
        }
        updateCheckoutState();
      });
    return saveChain;
  }
  async function beforeCheckout(replay) {
    try {
      if (
        !Array.from(cartStates.values())
          .filter(function (state) {
            return state.node.isConnected;
          })
          .every(function (state) {
            return valid(state, true);
          })
      )
        return;
      do {
        await saveAll();
      } while (
        Array.from(cartStates.values()).some(function (state) {
          return state.dirty && state.node.isConnected;
        })
      );
      replayingCheckout = true;
      replay();
      replayingCheckout = false;
    } catch (_) {
      replayingCheckout = false;
    }
  }
  var cartForm = cartList.closest("form");
  cartForm.addEventListener(
    "click",
    function (event) {
      var checkout = event.target.closest(
        '[name="checkout"], a[href="/checkout"]',
      );
      if (
        !checkout ||
        replayingCheckout ||
        !document.body.hasAttribute("data-ddey-course-roster-blocked")
      )
        return;
      event.preventDefault();
      event.stopImmediatePropagation();
      beforeCheckout(function () {
        checkout.click();
      });
    },
    true,
  );
  cartForm.addEventListener(
    "submit",
    function (event) {
      if (
        replayingCheckout ||
        !document.body.hasAttribute("data-ddey-course-roster-blocked") ||
        !event.submitter ||
        event.submitter.name !== "checkout"
      )
        return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var button = event.submitter;
      beforeCheckout(function () {
        cartForm.requestSubmit(button);
      });
    },
    true,
  );
  var observer = new MutationObserver(function (records) {
    if (
      !records.some(function (record) {
        return !record.target.closest("[data-ddey-cart-course-students]");
      })
    )
      return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 100);
  });
  observer.observe(cartList, { childList: true, subtree: true });
  refresh();
})();

